module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_5012.46ee3548.png";